import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a83037b8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a83037b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83037b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a83037b8')) {
      api.createRecord('a83037b8', component.options)
    } else {
      api.reload('a83037b8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a83037b8&scoped=true&", function () {
      api.rerender('a83037b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/email-info/index.vue"
export default component.exports